// libs
import React, { memo, lazy, Suspense } from 'react';

const AddToCartTool = lazy(() => import('./addToCartTool'));
const CompareProductTool = lazy(() => import('./CompareProductTool'));
const AskProductTool = lazy(() => import('./AskProductTool'));
const DeliveryCheckTool = lazy(() => import('shared/layouts/DetailsPage/components/ProductInfo/components/PinCodeServiceNewV2/DeliveryCheckTool'));

// components
import ProductImage from 'shared/layouts/DetailsPage/components/ProductImage/Desktop';
import ProductInfo from 'shared/layouts/DetailsPage/components/ProductInfo/Desktop';
import RecentlyViewedObserver from 'layouts/DetailsPage/components/RecentlyViewedObserver';

// styles
import {
  DetailContainer,
  ImageContainerMobile,
  ImageContainerDesktop,
  ProductInfoContainer,
} from './styles';

// context
import { useResponsiveContext } from 'shared/components/ResponsiveLoader/ResponsiveContext';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

// constants
import { BREAKPOINTS } from 'shared/styles/base';
import CartNudgeProvider from 'shared/layouts/DetailsPage/components/CartNudgeProvider/CartNudgeProvider';

function ProductDetail() {
  const { deviceWidth } = useResponsiveContext();
  const { enabled: mcpEnabled, feature: mcpFeature } = useRemoteConfig('webMcpFeature');
  const ImageContainer =
    deviceWidth && deviceWidth > BREAKPOINTS.DESKTOP ? ImageContainerDesktop : ImageContainerMobile;
  return (
    <>
      {mcpEnabled && (
        <Suspense fallback={null}>
          {mcpFeature.addToCart && <AddToCartTool />}
          {mcpFeature.checkDelivery && <DeliveryCheckTool />}
          {mcpFeature.compare && <CompareProductTool />}
          <AskProductTool />
        </Suspense>
      )}
      <DetailContainer>
        <ImageContainer>
          <ProductImage />
        </ImageContainer>
        <ProductInfoContainer>
          <CartNudgeProvider>
            <ProductInfo />
          </CartNudgeProvider>
        </ProductInfoContainer>
      </DetailContainer>
      <RecentlyViewedObserver />
    </>
  );
}

export default memo(ProductDetail);
